/** @format */

export default {
  appName: '',
  se: {
    title: '安徽智慧教育平台',
    enTitle: 'Smart Education of Anhui'
  }
};
